<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cyafJx/tc-custom/9781439146699.jpg?1730522511172" alt="This image is the cover for the book You're Certifiable"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You're Certifiable
      </h1>
      <p class="bookDescription body article font2">
        <b>700 PATHS TO A JOB YOU LOVE</b><br/>Are you established in a career but feeling the need for a change? Interested in starting your own business and looking for an alternative to the more traditional enterprises? Graduating from college (or high school) and wondering what to do now? If you are searching for an offbeat, soul-satisfying profession that offers more than just a paycheck, enrolling in a certification program could be the perfect first step to finding the job that is made for you.<br/><i>You're Certifiable</i> is packed with more than 700 ideas for alternative careers as well as all the information that you need to embark on your chosen field, such as:<br/><b>* Holistic health:</b> from acupressure to hypnotherapy<br/><b>* Crafts:</b> From violin making to glassblowing<br/><b>* Art and design:</b> from museum studies to Feng Shui<br/><b>* Working with animals:</b> from horse training to pet grooming<br/><b>* Outdoor pursuits:</b> from diving to hot-air balloon piloting<br/><b>* Food and drink:</b> from beer brewing to cake decorating<br/>The first-ever comprehensive directory of certification programs throughout the country, <i>You're Certifiable</i> provides the essentials on how to get certified in the career of your choice, how long it will take, how much it costs, and what to expect once you start working. Lee and Joel Naftali have gathered all the tools you need to find your perfect niche in the professional world.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Naftali, Joel Naftali
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e6730e2e